import React from 'react'
import i18n from 'i18next'
import * as R from 'ramda'

import QuestionSection from './QuestionSection'

const getTooltip = (question, usedInOtherSurveys, appStore) => {
    const { metadata: { oid } } = question

    if (oid === 1) return i18n.t('translation.exploriQuestion')
    if (oid < 6) return i18n.t('translation.clientQuestion', { clientName: R.path(['userData', 'clientName'], appStore) })
    if (usedInOtherSurveys) return i18n.t('translation.linkedQuestion')

    return null
}

const getQuestion = (question, editableQuestions, allowEditing, usedInOtherSurveys) => {
    const { id, metadata: { oid } } = question

    if (!allowEditing || usedInOtherSurveys || oid < 6) return question

    return editableQuestions.get(id.toUpperCase())
}

const PageSection = ({ page, defaultLocale, targetLocale, show, togglePage, appStore, allowEditing, editableQuestions }) => (
    <>
        <tr className="bg_gray">
            <td className="oid" />
            <td colSpan={3} style={{ padding: '4px 16px' }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <b>
                            {i18n.t('s_page')}
                            {' '}
                            {page.priority}
                        </b>
                    </div>
                    <div className="chevron" onClick={() => { togglePage(page.id) }}>
                        <i className={`fa ${show ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true" />
                    </div>
                </div>
            </td>
        </tr>
        {show && (
            R.pathOr([], ['questions'], page).map(({ question, usedInOtherSurveys }) => (
                <QuestionSection
                    mode="survey"
                    question={getQuestion(question, editableQuestions, allowEditing, usedInOtherSurveys)}
                    defaultLocale={defaultLocale}
                    targetLocale={targetLocale}
                    isDisabled={!allowEditing || question.metadata.oid < 6 || usedInOtherSurveys}
                    hideLock={(question.metadata.oid >= 6 && !usedInOtherSurveys)}
                    tooltip={getTooltip(question, usedInOtherSurveys, appStore)}
                />
            ))
        )}
    </>
)

export default PageSection
